import { render } from "./BarcodeInfoLabel.vue?vue&type=template&id=d8f8b71c&scoped=true"
import script from "./BarcodeInfoLabel.vue?vue&type=script&lang=ts"
export * from "./BarcodeInfoLabel.vue?vue&type=script&lang=ts"

import "./BarcodeInfoLabel.vue?vue&type=style&index=0&id=d8f8b71c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d8f8b71c"

export default script